import z from "zod";

export const configurationSchema = z
  .object({
    municipalityName: z.string().min(1, "Nome do município é obrigatório"),
    municipalityState: z.string().min(1, "Estado é obrigatório"),
    estimatedPopulation: z
      .number()
      .positive("População deve ser um número positivo"),
    contactEmail: z
      .string()
      .min(1, "E-mail de contato é obrigatório")
      .email("E-mail inválido"),
    slaCriticalDays: z.number().positive("SLA deve ser um número positivo"),
    slaHighDays: z.number().positive("SLA deve ser um número positivo"),
    slaMediumDays: z.number().positive("SLA deve ser um número positivo"),
    slaLowDays: z.number().positive("SLA deve ser um número positivo"),
    deduplicationRadiusMeters: z
      .number()
      .positive("Raio deve ser um número positivo"),
    deduplicationTimeWindowDays: z
      .number()
      .positive("Janela de tempo deve ser um número positivo"),
    occurrenceReopeningDeadlineDays: z
      .number()
      .positive("Prazo deve ser um número positivo"),
  })
  .refine((data) => data.slaCriticalDays < data.slaHighDays, {
    message: "SLA Crítica deve ser menor que SLA Alta",
    path: ["slaCriticalDays"],
  })
  .refine((data) => data.slaHighDays < data.slaMediumDays, {
    message: "SLA Alta deve ser menor que SLA Média",
    path: ["slaHighDays"],
  })
  .refine((data) => data.slaMediumDays < data.slaLowDays, {
    message: "SLA Média deve ser menor que SLA Baixa",
    path: ["slaMediumDays"],
  });

export type ConfigurationFormData = z.infer<typeof configurationSchema>;
